module.exports = __webpack_public_path__ + "img/ivy-empty.56e11826.png";